/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { MainnetOtpStartResponse, MainnetOtpStartVars } from '../openapi-types.gen.js';

export type { MainnetOtpStartResponse, MainnetOtpStartVars } from '../openapi-types.gen.js';

export const useMainnetOtpStart = createMutationHook<MainnetOtpStartVars, MainnetOtpStartResponse, unknown>({
  specName: 'useMainnetOtpStart',
  path: '/v1/notifications/mainnet/otp/start',
  method: 'POST',
  resolveUrl: (vars: MainnetOtpStartVars) => `/v1/notifications/mainnet/otp/start`,
  buildBody: (vars: MainnetOtpStartVars) => ({ email: vars.email, locale: vars.locale, source: vars.source, consent: vars.consent, referralCode: vars.referralCode, xToken: vars.xToken }),
  parseResponse: (raw: unknown): MainnetOtpStartResponse => raw as MainnetOtpStartResponse,
  
  
  
});
